var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 127,
    viewBox: "0 0 117 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.5 114.8L112 61.2996L58.5 7.79956L5 61.2996L58.5 114.8Z",
    fill: "#094B6B",
    stroke: "#1293D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3391 78.8H77V65.2435C77 58.5883 75.5678 53.4721 67.8028 53.4721C66.3458 53.4178 64.9014 53.7604 63.6235 54.4633C62.3455 55.1662 61.2818 56.2032 60.5456 57.4638H60.4465V54.086H53.0921V78.7991H60.7529V66.5687C60.7529 63.345 61.3639 60.2226 65.354 60.2226C69.2876 60.2226 69.3391 63.9132 69.3391 66.7793V78.8Z",
    fill: "#1293D2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9768 49.9572C42.7081 50.4465 43.5679 50.7075 44.4473 50.7073C45.6264 50.707 46.7571 50.2377 47.5907 49.4025C48.4244 48.5673 48.8927 47.4347 48.8927 46.2537C48.8927 45.3728 48.6319 44.5117 48.1433 43.7793C47.6547 43.0469 46.9602 42.476 46.1477 42.139C45.3351 41.8019 44.4411 41.7138 43.5785 41.8857C42.716 42.0576 41.9238 42.4819 41.302 43.1048C40.6802 43.7278 40.2568 44.5214 40.0853 45.3854C39.9139 46.2494 40.0021 47.1449 40.3387 47.9587C40.6754 48.7725 41.2455 49.468 41.9768 49.9572Z",
    fill: "#1293D2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.609 78.7991H48.2778L48.2788 54.086H40.609V78.7991Z",
    fill: "#1293D2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinBack);
export default __webpack_public_path__ + "static/media/linkedin-back.c54fdccb4e403c8661c7c179d48bfc3d.svg";
export { ForwardRef as ReactComponent };